import QueryString from "qs";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { IClassTestInfo, ITestStudent } from "../../../models/tutor.model";
import ClassTest from "../../class/class/ClassTest";
import TestScore from "../../class/class/TestScore";

const Test = () => {
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const classCode = String(query.classCode);

  const [tab, setTab] = useState('test');
  const [testRecord, setTestRecord] = useState<IClassTestInfo>();
  const [studentRecord, setStudentRecord] = useState<ITestStudent>();

  const renderTabContent = () => {
    switch (tab) {
      case 'test':
        return (
          <ClassTest
            setTab={setTab}
            testRecord={testRecord}
            setTestRecord={setTestRecord}
            setStudentRecord={setStudentRecord}
            classCode={classCode}
          />
        );
      case 'testScore':
        return (
          <TestScore
            setTab={setTab}
            testRecord={testRecord}
            studentRecord={studentRecord}
          />
        );
      default:
        return null;
    }
  }

  return renderTabContent();
}

export default Test;
